import { render, staticRenderFns } from "./InfomationForm.vue?vue&type=template&id=777e89b6&scoped=true"
import script from "./InfomationForm.vue?vue&type=script&lang=js"
export * from "./InfomationForm.vue?vue&type=script&lang=js"
import style0 from "./InfomationForm.vue?vue&type=style&index=0&id=777e89b6&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "777e89b6",
  null
  
)

export default component.exports